// @flow weak
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {PatientActions}  from '../reducers/patient/index'
import {
    Button,
    Col,
    Row
} from '@sketchpixy/rubix'
import LoadingContainer from "../components/LoadingContainerCorrect";
import LoadingContainerOld from "../components/LoadingContainer";
import NotificationSystem from 'react-notification-system';
import {FIELD_STATUSES} from '../utils'


class Review extends Component {
    constructor(props) {
        super(props)
        this.state = {
            pDoc: props && props.location && props.location.pDoc ? props.location.pDoc : JSON.parse(sessionStorage.getItem('pDoc')),
            questions: '',
            correctedFileURL: sessionStorage.getItem('correctedFileURL') ? sessionStorage.getItem('correctedFileURL') :'',
            signedFileURL: sessionStorage.getItem('signedFileURL') ? sessionStorage.getItem('signedFileURL') :'',
            highlightedFileURL: sessionStorage.getItem('highlightedFileURL') ? sessionStorage.getItem('highlightedFileURL') :'',
            correctedFileName: sessionStorage.getItem('correctedFileName') ? sessionStorage.getItem('correctedFileName') :'',
            signedFileName: sessionStorage.getItem('signedFileName') ? sessionStorage.getItem('signedFileName') :'',
            
            showSpinner: false,
            showSpinnerOld: false,
            note: sessionStorage.getItem("note") ? JSON.parse(sessionStorage.getItem("note")): {}
        }
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem

        this.loadCorrectedDoc()
    }

    loadCorrectedDoc = async () => {
        try {
            this.setState({showSpinnerOld: true})
            let body = {
                dbqId : this.state.pDoc.dbqId,
                dbqFormNo: this.state.pDoc.formNo,
                apptId: this.state.pDoc.apptId,
            }
            let token = localStorage.getItem('login_token');
            let headers = {"Content-Type": "application/json"};
            headers["Authorization"] = `Bearer ${token}`
            console.log("RESULTS BACK!!!!", body);

            const res = await fetch(process.env.API_URL+"/patients/corrected/doc", {method: "post", headers, body: JSON.stringify(body)} )
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        this.setState({ signedFileName: data.signedFileName, correctedFileName: data.correctedFileName, note: data.note })
                        sessionStorage.setItem("note", JSON.stringify(data.note))
                        sessionStorage.setItem("signedFileName", data.signedFileName)
                        sessionStorage.setItem("correctedFileName", data.correctedFileName)

                        return data;
                    } else {
                        this._addNotification(data.message, 'error', 'Error : ');
                    }    
                });
            
            const fileNameCorrected = res.correctedFileName;
      
            const correctedFileRes = await fetch(`${process.env.API_URL}/file/${fileNameCorrected}`, {
                method: 'GET',
                headers,
            });

            if (!correctedFileRes.ok) throw new Error("Failed to fetch PDF");

            const blob = await correctedFileRes.blob();
            const fileUrl = URL.createObjectURL(blob);

            this.setState({ correctedFileURL: fileUrl });
        } catch (error) {
            console.error("PDF Fetch Error:", error);
        } finally {
            this.setState({ showSpinnerOld: false });
        }
    }

    highlightChanges = async () => {
        try {
            this.setState({ showSpinner: true })
            let token = localStorage.getItem('login_token');
            let headers = {"Content-Type": "application/json"};
            headers["Authorization"] = `Bearer ${token}`

            const res = await fetch(process.env.API_URL+"/patients/highlight/doc", {method: "post", headers, body: JSON.stringify(this.state)} )
            .then(response => response.json())
            .then(data => {
                if (data.valid) {
                    this.setState({ correctedFileName: data.correctedFileName })
                    if (!data.success) {
                        this._addNotification(data.message, 'success', 'Success : ');
                    }

                    return data;
                } else {
                    if (/incompatible versions/gi.test(data.message)) {
                        this._addNotification(
                            "The versions of the uploaded documents are different, so it's not possible to highlight changes between them. You can still proceed by selecting Accept Changes to sign the corrected DBQ.",
                            'info',
                            'Highlighting unavailable for these documents'
                        );
                        return {
                            signedFileName: this.state.signedFileName,
                            highlightedFileName: this.state.correctedFileName,
                        };
                    } else {
                        this._addNotification(data.message, 'error', 'Error : ');
                    }
                }        
            });

            const fileNameSigned = res.signedFileName || this.state.signedFileName;
            const fileNameHighlighted = res.highlightedFileName;

            const [signedFileRes, highlightedFileRes] = await Promise.all([
            fetch(`${process.env.API_URL}/file/${fileNameSigned}`, {
                method: 'GET',
                headers,
            }),
            fetch(`${process.env.API_URL}/file/${fileNameHighlighted}`, {
                method: 'GET',
                headers,
            })
            ]);

            if (!signedFileRes.ok) throw new Error("Failed to fetch signed PDF");
            if (!highlightedFileRes.ok) throw new Error("Failed to fetch highlighted PDF");

            const [signedBlob, correctedBlob] = await Promise.all([
            signedFileRes.blob(),
            highlightedFileRes.blob(),
            ]);

            const fileUrlSigned = URL.createObjectURL(signedBlob);
            const fileUrlCorrected = URL.createObjectURL(correctedBlob);

            this.setState({ signedFileURL: fileUrlSigned, highlightedFileURL: fileUrlCorrected });
        } catch (error) {
            console.error("PDF Fetch Error:", error);
        } finally {
            this.setState({ showSpinner: false });
        }
    }

    actions = link => {
        // if (!this.state.highlightedFileURL) {
        //     this._addNotification("Please wait DBQs are loading ...", 'error', 'Error Message: ');
        //     return
        // }
        const { history } = this.props
        history.push({
            pathname:link,
            disabilityNameSugar: this.state.pDoc.disabilityNameSugar,
            dbqId: this.state.pDoc.id,
            dbqCount: this.state.pDoc.dbqCount,
            patientName: this.state.pDoc.patientName,
            patientId: this.state.pDoc.patientId,
            correctedFileName: this.state.correctedFileName
        })
    }

    reject = link => {
        const { history } = this.props
        history.push({
            pathname:link,
            pDoc: this.state.pDoc
        })
    }

    // getTexts = () => {

    // }    

    componentWillReceiveProps(newProps) {
        let {patientInfo, fetching, isPatientUpdate, error} = newProps

        if (isPatientUpdate && !fetching) {
            const { history, location } = this.props
            history.push({pathname:'/admin/dbq', state:this.state.patient, file: patientInfo, patient:location.patient, questions: this.state.questions})
        } else {
            console.log("error", error)
            if(error) {
                this._addNotification(error, 'error', 'Error Message: ');
            }            
        }
    }
    _addNotification = (message, type, title) => {
        this._notificationSystem.clearNotifications()
        this._notificationSystem.addNotification({
            message,
            title: title,
            level: type,
            position: 'br',
            autoDismiss: 10
        })

        if (type === 'error') {
            this.setState({
                emailError: {
                    status: FIELD_STATUSES.ERROR,
                    message: ''
                },
                passwordError: {
                    status: FIELD_STATUSES.ERROR,
                    message: ''
                }
            })
        }
    }

    render() {
        const { note } = this.state;
        let highlightedFileURL = this.state.highlightedFileURL
        let signedFileURL = this.state.signedFileURL;
        let correctedFileURL = this.state.correctedFileURL;

        return (
            <div className="show-with-ease">
                <NotificationSystem ref='notificationSystem'/>
                {!this.state.showSpinnerOld && <Row className="">
                    <Col sm={2} md={2} lg={2} className="text-center" style={{padding: 0}}>
                    <div>{ this.state.pDoc.dbqName } </div>
                    <img className='dashboard-dbq disabality-name-tooltip dashboard-dbq-img-width' 
                        src={'/imgs/app/vbg-icons/' + this.state.pDoc.dbqName.toLowerCase() + '.png'} 
                        alt={this.state.pDoc.dbqName + ' image'}>
                    </img><div className='disabality-name-tooltip-text'>{ this.state.pDoc.patientName } </div>
                    </Col>
                    <Col sm={8} md={8} lg={8} className="text-center">
                        <h1 className="heading-main"><strong>{note ? note.name : "Note"}</strong></h1>
                        <div className="correct-note-div">{note ? note.description : "Unfortunately we could not find Notes for this case !!!"}</div>                    
                    </Col>
                </Row>}
                <br />
                { this.state.correctedFileURL ? <Row>
                    <Col xs={12} smOffset={1} sm={6}>
                    {this.state.showSpinner && <span style={{fontSize: 16}}>Please wait while the changes are being highlighted</span> }
                        
                    </Col>
                    <Col xs={12} sm={4}>
                    
                    <span className='pull-right'><Button
                            lg
                            type='button'
                            bsStyle='primary'
                            className="big-btn"
                            style={{textTransform: 'capitalize'}}
                            onClick={e => this.highlightChanges()}>highlight Changes
                        </Button></span>{this.state.showSpinner && <span className="spinner rotate pull-right" style={{marginRight: 12, marginTop: 8}}></span>}
                    </Col>
                </Row>: ""
                }

                {
                    this.state.correctedFileURL ?
                    <Row className="height400" style={{marginBottom: 50}}>
                    <Col xs={12} smOffset={1} sm={10} className="text-center">
                        <h1 className="heading-main">
                            <strong>Corrected DBQ </strong>
                        </h1>
                        {this.state.highlightedFileURL && <h4>
                            This is the new DBQ form with changes made by VBG. The changes are highlighted in yellow. The yellow highlights will be removed after you sign this DBQ
                        </h4>}
                        <div style={{marginTop:30}}>
                            <object width="100%" height="600" data={this.state.highlightedFileURL ? highlightedFileURL : this.state.correctedFileURL ? correctedFileURL : ""} type="application/pdf">   </object>
                        </div>
                    </Col>
                </Row>
                :""
                }

                {
                    this.state.signedFileURL && this.state.highlightedFileURL ?
                    <Row className="height400">
                    <Col xs={12} smOffset={1} sm={10} className="text-center">
                        <h1 className="heading-main">
                            <strong>Original DBQ</strong>
                        </h1>
                        <h4 className="">
                            This is the DBQ form you signed during the original appointment
                        </h4>
                        <div style={{marginTop:30}}>
                            <object width="100%" height="600" data={signedFileURL? signedFileURL: ""} type="application/pdf">   </object>
                        </div>
                    </Col>
                </Row>
                :""
                }

                
                {/* {
                    !this.state.showSpinner ? "": 
                    <Row>
                        <Col smOffset={1} lgOffset={3} sm={10} lg={6}>
                        <LoadingContainer />
                        </Col>
                    </Row>
                } */}

                {
                    this.state.showSpinnerOld ? 
                    <Row>
                        <Col smOffset={1} lgOffset={3} sm={10} lg={6}>
                        <LoadingContainerOld />
                        </Col>
                    </Row> : ""
                }
                
                
                {!this.state.showSpinnerOld && <Row className="button-bottom" style={{ bottom: 0 }}>
                    <Col smOffset={1} sm={5} style={{paddingTop: 50}}>
                        <Button
                            lg
                            type='button'
                            bsStyle='danger'
                            className="reject-btn big-btn"
                            style={{width: "260"}}
                            onClick={this.reject.bind(this, "/admin/note", 0)}>Reject Changes
                        </Button>
                    </Col>
                    <Col sm={5} 
                        className='text-right button-bottom' style={{paddingTop: 50}}>
                        <Button
                            lg
                            type='button'
                            bsStyle='primary'
                            className="big-btn"
                            style={{width: "260", textTransform: 'capitalize'}}
                            onClick={this.actions.bind(this, "/admin/signAgain")}>Accept Changes
                        </Button>
                    </Col>
                </Row>}

            </div>
        )
    }
}


const mapStateToProps = state => ({
    patient: {
        specific: {
            patientInfo, fetching, error, isPatientUpdate
        }
    },
  }) => {
   return {
    patientInfo,
    fetching,
    error,
    isPatientUpdate
   }
}

const mapDispatchToProps = dispatch => ({
    updatePatientDoc: (id, dbq, questions, ssn, status, patientName) => {
        dispatch(PatientActions.updateSpecificPatientRequest({
            id,
            dbq,
            questions,
            ssn,
            status,
            patientName
        }))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Review)
